import store from '@/store';
import { welcomeDigitalDiscountIsExperimentEnabled } from './welcomeDigitalDiscountExperiment';

/**
 * Determines if the welcome digital discount modal/banner should be shown.
 *
 * Cases:
 * 1. `WELCOME_DIGITAL_DISCOUNT_ENABLED` is false → false
 * 2. `welcomeDigitalDiscountIsExperimentEnabled()` is false (GrowthBook / SHOW_WELCOME_DIGITAL_DISCOUNT_BANNER
 *    rollout; not the trip-list {@link DiscountBanner}) → false
 * 3. `WELCOME_DIGITAL_DISCOUNT_ROUTES` is empty or absent → true (all routes allowed)
 * 4. Routes are defined → true only if origin/destination match a configured route
 *
 * @param {Object} params - The parameters object.
 * @param {string} params.originCityName - The origin city name.
 * @param {string} params.destinationCityName - The destination city name.
 * @returns {boolean} True if the discount should be shown, false otherwise.
 */
const shouldShowWelcomeDigitalDiscount = ({ originCityName, destinationCityName }) => {
  const { features } = store.getState().whitelabelConfig;
  const { WELCOME_DIGITAL_DISCOUNT_ENABLED, WELCOME_DIGITAL_DISCOUNT_ROUTES } = features;

  // Case 1: WELCOME_DIGITAL_DISCOUNT_ENABLED is false
  if (!WELCOME_DIGITAL_DISCOUNT_ENABLED) return false;

  // Case 2: welcomeDigitalDiscountIsExperimentEnabled / GrowthBook SHOW_WELCOME_DIGITAL_DISCOUNT_BANNER (not trip-list DiscountBanner)
  if (!welcomeDigitalDiscountIsExperimentEnabled()) return false;

  // Case 3: No route filter — show on all routes
  if (!WELCOME_DIGITAL_DISCOUNT_ROUTES || WELCOME_DIGITAL_DISCOUNT_ROUTES.length === 0) {
    return true;
  }

  // Case 4: Route filter — current origin/destination must match
  return WELCOME_DIGITAL_DISCOUNT_ROUTES.some(
    (route) => route.origin === originCityName && route.destination === destinationCityName,
  );
};

export default shouldShowWelcomeDigitalDiscount;
